import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './Resume.css';

function Resume({lang}) {
  const { version } = useParams();
  const navigate = useNavigate();
  const [currentVersion, setCurrentVersion] = useState(version || 'en');
    const resumeText = {
        zh: {
        switch: "切换语言",
        download: "下载简历",
        preview: "简历预览"
        },
        en: {
        switch: "Switch Language",
        download: "Download Resume",
        preview: "Resume Preview"
        }
    };
  useEffect(() => {
    if (version) setCurrentVersion(version);
  }, [version]);

  const pdfFiles = {
    zh: '/assets/Resume_CN.pdf',
    en: '/assets/Resume_EN.pdf'
  };

  const currentPath = pdfFiles[currentVersion];
    const t = resumeText[lang] || resumeText['en'];
  const handleToggle = () => {
    const nextVer = currentVersion === 'zh' ? 'en' : 'zh';
    navigate(`/resume/${nextVer}`);
  };

  return (
            <div className='resume-secction'>
            <div className="resume-container">
            <div className="resume-paper-wrapper">
                <div className="mobile-resume-tools">
                <button onClick={handleToggle} className="mobile-tool-btn">
                {currentVersion === 'zh' ? 'English' : '中文版'}
                </button>
                <div className="divider"></div>
                <a href={currentPath} download className="mobile-tool-btn">
                <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 16v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1"></path>
                    <polyline points="8 11 12 15 16 11"></polyline>
                    <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
                <span>{lang === 'zh' ? '下载' : 'Download'}</span>
                </a>
            </div>
                {/* 简历纸张本体 */}
                <div className="resume-paper">
                <iframe 
                    key={currentPath}
                    src={`${currentPath}#view=FitH&toolbar=0`} 
                    title="Resume Preview"
                    className="resume-iframe"
                ></iframe>
                </div>

                {/* ✅ 侧边浮动工具栏 - 现在放在 wrapper 内部 */}
                <div className="side-toolbar">
                <button onClick={handleToggle} className="side-btn" title={t.switch}>
                    {currentVersion === 'zh' ? 'EN' : '中'}
                </button>
                <a 
                        href={currentPath} 
                        download 
                        className="side-btn" 
                        title={lang === 'zh' ? '下载简历' : 'Download Resume'}
                        >
                        <svg 
                            viewBox="0 0 24 24" 
                            width="20" 
                            height="20" 
                            stroke="currentColor" 
                            strokeWidth="2.2" 
                            fill="none" 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            className="download-icon-svg"
                        >
                            {/* 底部托盘：带有圆角的开口容器 */}
                            <path d="M4 16v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1"></path>
                            {/* 垂直箭头：直线 + V字型 */}
                            <line x1="12" y1="3" x2="12" y2="15"></line>
                            <polyline points="8 11 12 15 16 11"></polyline>
                        </svg>
                        </a>
                </div>
            </div>
            </div>
</div>
  );
}

export default Resume;